<!-- Jobs and tasks list -->
<div
  class="ch-panel"
  style="flex-basis: 33.333%"
  chPaidOverlay
  [ctaText]="'Coordinate work, track deadlines, and much more'"
  [ctaVideo]="'https://youtu.be/GHGBbOgFavs'"
  [ngClass]="{ 'panel-hidden': isPanelJobsHidden }"
>
  <div class="ch-panel-title">
    <div class="toggle-panel" (click)="togglePanel('jobs')">
      <i class="feather minus ch-panel-icon-title"></i> Jobs
    </div>
    @if (templateManager) {
      <span> Templates</span>
    }

    <div
      class="view-type d-flex"
      (click)="templateManager ? newJobTemplate() : newJob()"
      tooltip="Create a Job"
    >
      <i class="primary feather plus"></i>
    </div>
    <div
      class="view-type d-flex"
      tooltip="Magic Workflow (AI)"
      (click)="openCreateAIJobModal(createAIJobModal)"
      style="right: 50px"
    >
      <i class="tio-magic_wand"></i>
    </div>

    <div
      class="view-type d-flex"
      dropdown
      [dropup]="false"
      [autoClose]="true"
      [insideClick]="true"
      style="right: 93px"
      (click)="setFocusOnTemplateListInput()"
      tooltip="Load from Templates"
    >
      <div dropdownToggle class="dropdown-toggle">
        <i class="tio-files_outlined"></i>
      </div>
      <ul
        *dropdownMenu
        role="menu"
        class="dropdown-menu"
        style="
          padding: 0;
          border: none;
          box-shadow: none;
          min-width: 260px;
          font-size: 1rem;
          margin-left: -23px;
          margin-top: 2px;
          overflow: initial;
        "
      >
        <li>
          <form
            class="choose-template no-animation"
            [formGroup]="templatesForm"
          >
            <input
              #templateListInput
              formControlName="templates"
              [typeahead]="templates"
              (typeaheadOnSelect)="typeaheadOnSelect($event, createJobModal)"
              [typeaheadOptionsLimit]="9999"
              [typeaheadMinLength]="0"
              typeaheadOptionField="name"
              placeholder="Load from template"
              class="form-control"
            />
          </form>
        </li>
      </ul>
    </div>
  </div>

  @if (sharedDataService.subscriptionType != "free") {
    <div class="jobs-sort hide-panel-hidden">
      <div dropdown [autoClose]="true" class="due-date-dropdown" container="body">
        <div dropdownToggle class="dropdown-toggle">
          <i class="tio-sort"></i> {{ sortByLabel }}
          <i class="feather chevron-down"></i>
        </div>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li>
            <a (click)="changeSortBy('due_date', 'Due Date')">Due Date</a>
          </li>
          <li>
            <a (click)="changeSortBy('target_start_date', 'Start Date')"
              >Start Date</a
            >
          </li>
          <li>
            <a (click)="changeSortBy('name', 'Name')">Name</a>
          </li>
          <li>
            <a (click)="changeSortBy('assigned_to', 'Assigned To')"
              >Assigned To</a
            >
          </li>
          <li>
            <a (click)="changeSortBy('status', 'Status')">Status</a>
          </li>
        </ul>
      </div>
    </div>
  }

  <!-- List of jobs -->
  <div class="ch-panel-content">
    @if (!templateManager) {
      <div class="ch-tabs" style="margin: 0 15px">
        <div
          [ngClass]="{ active: jobsStore.activeTab == 'current' }"
          (click)="switchJobsTabs('current')"
        >
          Open
        </div>
        <!-- <div
        [ngClass]="{ active: jobsStore.activeTab == 'future' }"
        (click)="switchJobsTabs('future')"
        >
        Future
      </div> -->
        <div
          [ngClass]="{ active: jobsStore.activeTab == 'completed' }"
          (click)="switchJobsTabs('completed')"
        >
          Completed
        </div>
        <!-- The sort by dropdown goes here -->
      </div>
    }

    <!-- component-loading -->
    <div
      id="jobs-tab"
      class="ch-tabs-content-wrapper overflow-auto"
      [ngClass]="{ 'component-loading': loading }"
    >
      @for (j of jobsStore.jobs[jobsStore.activeTab]; track j) {
        <app-jobs-and-tasks-card [job]="j" (click)="selectJob(j)">
        </app-jobs-and-tasks-card>
      }
      @if (
        jobsStore.jobs[jobsStore.activeTab].length > 0 &&
        jobsStore.jobs[jobsStore.activeTab].length % 25 == 0 &&
        loading == false
      ) {
        <div class="load-messages-wrapper">
          <a
            class="btn btn-primary-light"
            (click)="loadMoreJobs(jobsStore.activeTab)"
            >Load More</a
          >
        </div>
      }
      @if (
        jobsStore.jobs[jobsStore.activeTab].length == 0 && loading == false
      ) {
        <div id="jobs-empty-state" class="jobs-empty-state">
          <div
            class="emoji animated fadeInUp delay-3"
            style="margin-bottom: 16px; margin-top: -24px"
          >
            <svg
              width="142"
              height="77"
              viewBox="0 0 142 77"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d)">
                <path
                  d="M132 10H10C5.58172 10 2 13.5817 2 18V65C2 69.4183 5.58172 73 10 73H132C136.418 73 140 69.4183 140 65V18C140 13.5817 136.418 10 132 10Z"
                  fill="white"
                />
                <path
                  d="M132 10.5H10C5.85786 10.5 2.5 13.8579 2.5 18V65C2.5 69.1421 5.85786 72.5 10 72.5H132C136.142 72.5 139.5 69.1421 139.5 65V18C139.5 13.8579 136.142 10.5 132 10.5Z"
                  stroke="#EBEDF0"
                />
              </g>
              <path
                opacity="0.3"
                d="M54 22.043H16C13.2386 22.043 11 24.2815 11 27.043C11 29.8044 13.2386 32.043 16 32.043H54C56.7614 32.043 59 29.8044 59 27.043C59 24.2815 56.7614 22.043 54 22.043Z"
                fill="#151C29"
              />
              <path
                opacity="0.3"
                d="M62 37.043H16C13.2386 37.043 11 39.2815 11 42.043C11 44.8044 13.2386 47.043 16 47.043H62C64.7614 47.043 67 44.8044 67 42.043C67 39.2815 64.7614 37.043 62 37.043Z"
                fill="#485364"
              />
              <path
                opacity="0.3"
                d="M34 52.043H16C13.2386 52.043 11 54.2815 11 57.043C11 59.8044 13.2386 62.043 16 62.043H34C36.7614 62.043 39 59.8044 39 57.043C39 54.2815 36.7614 52.043 34 52.043Z"
                fill="#C9CCD1"
              />
              <path
                opacity="0.8"
                d="M90.4649 24.2843L92.1017 28.7221C92.1632 28.8892 92.3223 29 92.5001 29C92.678 29 92.837 28.8892 92.8986 28.7221L94.5353 24.2843C95.8602 20.6916 98.6922 17.8596 102.285 16.5349L106.722 14.8982C106.889 14.8367 107 14.6776 107 14.4997C107 14.3219 106.889 14.1628 106.722 14.1013L102.284 12.4646C98.692 11.1397 95.8599 8.30787 94.5353 4.71544L92.8986 0.277629C92.837 0.110802 92.678 0 92.5001 0C92.3223 0 92.1632 0.110802 92.1017 0.277629L90.4649 4.71544C89.1401 8.30787 86.3083 11.1397 82.7157 12.4646L78.2776 14.1013C78.1108 14.1628 78 14.3219 78 14.4997C78 14.6776 78.1108 14.8367 78.2776 14.8982L82.7154 16.5349C86.308 17.8596 89.1401 20.6914 90.4649 24.2843Z"
                fill="#0075FF"
              />
              <path
                opacity="0.6"
                d="M41.8998 73.3385L43.0684 76.507C43.1123 76.6263 43.2259 76.7054 43.3529 76.7054C43.4799 76.7054 43.5934 76.6263 43.6374 76.507L44.806 73.3385C45.7519 70.7734 47.7739 68.7514 50.3389 67.8056L53.5074 66.637C53.6265 66.5931 53.7056 66.4795 53.7056 66.3525C53.7056 66.2256 53.6265 66.112 53.5074 66.068L50.3387 64.8994C47.7738 63.9535 45.7517 61.9316 44.806 59.3667L43.6374 56.1982C43.5934 56.0791 43.4799 56 43.3529 56C43.2259 56 43.1123 56.0791 43.0684 56.1982L41.8998 59.3667C40.9539 61.9316 38.932 63.9535 36.3669 64.8994L33.1982 66.068C33.0791 66.112 33 66.2256 33 66.3525C33 66.4795 33.0791 66.5931 33.1982 66.637L36.3667 67.8056C38.9318 68.7514 40.9539 70.7732 41.8998 73.3385Z"
                fill="#0075FF"
              />
              <path
                opacity="0.3"
                d="M121.728 75.2113L122.349 76.8946C122.372 76.958 122.433 77 122.5 77C122.568 77 122.628 76.958 122.651 76.8946L123.272 75.2113C123.775 73.8485 124.849 72.7743 126.211 72.2719L127.895 71.651C127.958 71.6277 128 71.5674 128 71.4999C128 71.4325 127.958 71.3721 127.895 71.3488L126.211 70.7279C124.849 70.2254 123.774 69.1513 123.272 67.7886L122.651 66.1053C122.628 66.042 122.568 66 122.5 66C122.433 66 122.372 66.042 122.349 66.1053L121.728 67.7886C121.226 69.1513 120.151 70.2254 118.789 70.7279L117.105 71.3488C117.042 71.3721 117 71.4325 117 71.4999C117 71.5674 117.042 71.6277 117.105 71.651L118.789 72.2719C120.151 72.7743 121.226 73.8485 121.728 75.2113Z"
                fill="#0075FF"
              />
              <defs>
                <filter
                  id="filter0_d"
                  x="0"
                  y="9"
                  width="142"
                  height="67"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  />
                  <feOffset dy="1" />
                  <feGaussianBlur stdDeviation="1" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <h4 class="animated fadeInUp delay-3">No jobs</h4>
          <p class="animated fadeInUp delay-3">There are no jobs to show.</p>
        </div>
      }
    </div>
  </div>
</div>

@if (!templateManager) {
  <app-pinned-panel></app-pinned-panel>
}
@if (!templateManager) {
  <app-notes></app-notes>
}

<!-- Emails panel -->

<div
  class="ch-panel"
  chPaidOverlay
  style="background: rgba(246, 247, 249, 0.451)"
  [ngClass]="{ 'panel-hidden': isPanelEmailHidden }"
>
  <div class="ch-panel-title">
    <div class="toggle-panel" (click)="togglePanel('email')">
      <i class="feather minus ch-panel-icon-title"></i> Email
    </div>
  </div>
  <div class="ch-panel-content ch-panel-component">
    <div
      id="jobs-tab"
      class="ch-tabs-content-wrapper"
      [ngClass]="{ 'component-loading': emailsLoading }"
    >
      @for (email of emails; track email) {
        <email-card [email]="email" style="margin-bottom: 15px"></email-card>
      }
      @if (emails?.length == 0 && !emailsLoading) {
        <div class="empty-state empty-state-absolute text-center">
          <i
            class="feather mail animated fadeInUp delay-3"
            style="font-size: 64px; opacity: 0.3"
          ></i>
          <h4 class="mt-4 animated fadeInUp delay-3">No emails</h4>
          <p class="animated fadeInUp delay-3">
            There are no emails to display.
          </p>
        </div>
      }
    </div>
  </div>

  <ng-template #createJobModal id="createJobModal">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="modalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Create Job</h4>
    </div>
    <div class="modal-body text-center create-job-modal">
      <i class="feather clipboard x3" style="color: #0075ff"></i>
      <h4>
        Do you want to create a job from "{{ duplicateSelectedObj.name }}"
        template?
      </h4>
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default pull-left"
        aria-label="Cancel"
        (click)="hideCopyModal()"
      >
        Cancel
      </div>
      <button
        class="btn btn-primary pull-right"
        (click)="
          duplicateJob({
            target_start_date: duplicateSelectedObj.target_start_date,
            due_date: duplicateSelectedObj.due_date,
            assigned_to_id:
              duplicateSelectedObj.assigned_to != null
                ? duplicateSelectedObj.assigned_to.id
                : null,
          })
        "
      >
        Create Job
      </button>
    </div>
  </ng-template>

  <ng-template #createAIJobModal id="createAIJobModal">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="modalRef.hide()"
        aria-label="Close"
        [disabled]="loading"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Magic Workflow</h4>
    </div>
    <div
      class="modal-body white text-center create-job-modal"
      [ngClass]="{ 'is-loading': loading }"
    >
      <div class="ai-bot-wrapper">
        <div class="ai-bot-face ai-bot-loading-wrapper">
          <img
            class="ai-bot-face ai-bot-loading"
            src="/assets/img/ai-bot-loading.svg"
          />
          <img
            class="ai-bot-face ai-bot-sparkles"
            src="/assets/img/ai-bot-sparkles.svg"
          />
        </div>
        <img
          class="ai-bot-face ai-bot-eyes"
          src="/assets/img/ai-bot-eyes.svg"
        />
        <img
          class="ai-bot animated"
          src="/assets/img/ai-bot.svg"
          alt="AI Bot avatar"
        />
        <svg
          class="ai-bot-shadow"
          width="134"
          height="28"
          viewBox="0 0 134 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="67" cy="14" rx="67" ry="14" fill="#E6E9ED" />
        </svg>
      </div>
      <div class="default-content">
        <h3 class="mt-0 mb-2">Briefly describe the job that you need to do</h3>
        <p>We will auto-generate tasks and task details for it using AI.</p>
        <div class="row">
          <div class="col-sm-1"></div>
          <div class="col-sm-10">
            <textarea
              class="form-control chat-input my-4"
              autosize
              [(ngModel)]="aiJobDescription"
              placeholder="e.g. 1099 tax form"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="loading-content">
        <h3 class="mt-0 mb-2">Generating Job using AI</h3>
        <p>Please wait, it may take up to 30 seconds.</p>
      </div>
    </div>
    <div class="modal-footer">
      @if (!loading) {
        <div
          class="btn btn-default pull-left"
          aria-label="Cancel"
          (click)="modalRef.hide()"
          [disabled]="loading"
        >
          Cancel
        </div>
      }
      <button
        class="btn btn-primary pull-right"
        (click)="createAIJob()"
        [disabled]="loading"
      >
        Generate Job
      </button>
    </div>
  </ng-template>

  <ng-template #askJobQuestionModal id="askJobQuestionModal">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="modalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Ask Job Question</h4>
    </div>
    <div class="modal-body text-center create-job-modal">
      <h4>Type your question</h4>

      <textarea
        class="form-control chat-input"
        autosize
        [(ngModel)]="jobQuestion"
      ></textarea>
      <br />
      {{ jobAnswer }}
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default pull-left"
        aria-label="Cancel"
        (click)="jobAnswer = ''; modalRef.hide()"
      >
        Cancel
      </div>
      <button class="btn btn-primary pull-right" (click)="askJobQuestion()">
        Ask Question
      </button>
    </div>
  </ng-template>
</div>
